<aside class="al-sidebar" id="leftsidebar" sidebarResize>
  <ba-menu
    [menuHeight]="menuHeight"
    [sidebarCollapsed]="isMenuCollapsed"
    (expandMenu)="menuExpand()"
  ></ba-menu>
</aside>
<!-- <aside>
  <mat-drawer-container class="example-container" autosize>
    <mat-drawer #drawer class="example-sidenav" mode="side">
      <p>Auto-resizing sidenav</p>
      <p *ngIf="showFiller">Lorem, ipsum dolor sit amet consectetur.</p>
      <button (click)="showFiller = !showFiller" mat-raised-button>
        Toggle extra text
      </button>
    </mat-drawer>

    <div class="example-sidenav-content">
      <button type="button" mat-button (click)="drawer.toggle()">
        Toggle sidenav
      </button>
    </div>
  </mat-drawer-container>
</aside> -->
